import React, { useState } from "react";
import InstallBanner from './components/InstallBanner';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar"; 
import Shop from "./components/Shop";
import Checkout from "./components/Checkout";
import OrderSuccess from "./components/OrderSuccess";
import TrackOrder from "./components/TrackOrder";
import Signup from "./components/Signup";
import Login from "./components/Login";
import AdminLogin from "./components/AdminLogin";
import Admin from "./components/Admin";
import ForgotPassword from "./components/ForgotPassword"
import MyOrders from "./components/MyOrders";
import About from './components/About';
import Contact from './components/Contact';

function App() {
  const [cart, setCart] = useState(
    JSON.parse(localStorage.getItem("cart")) || []
  );

  // 🟢 NEW: Calculate total items in cart for the red badge
  const cartCount = cart.reduce((acc, item) => acc + item.quantity, 0);

  return (
    <Router>
      {/* 🟢 UPDATED: Passing the count to the Navbar */}
      <Navbar cartCount={cartCount} /> 
      
      {/* 🟢 NEW: PWA Install Banner placed globally! */}
      <InstallBanner />
      
      <Routes>
        <Route path="/" element={<Shop cart={cart} setCart={setCart} />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/my-orders" element={<MyOrders />} />
        <Route path="/login" element={<Login />} />
        <Route path="/checkout" element={<Checkout cart={cart} setCart={setCart} />} />
        <Route path="/order-success" element={<OrderSuccess />} />
        <Route path="/track-order" element={<TrackOrder />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        
        {/* ADMIN ROUTES */}
        <Route path="/admin-login" element={<AdminLogin />} />
        <Route path="/admin" element={<Admin />} />

        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />

        {/* Fallback to Shop */}
        <Route path="*" element={<Shop cart={cart} setCart={setCart} />} />
      </Routes>
    </Router>
  );
}

export default App;